import _objectWithoutProperties from "/home/runner/work/zettel/zettel/site/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "img",
    components: components,
    parentName: "p",
    props: {
      "src": "logo_small.png",
      "alt": "Zettel"
    }
  })), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "h2",
    props: {
      "href": "https://zettel.software"
    }
  }, "Zettel")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "(API still subject to change - don't use this in production just yet)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "A radically different (much simpler and lower level) approach to building text editors in the browser."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://join.slack.com/t/zetteljs/shared_invite/zt-eiih8wis-Hca9bcrvX3V728odwEqiBA"
    }
  }, "Join Zettel on Slack")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://badge.fury.io/js/%40zettel%2Fcore"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "img",
    components: components,
    parentName: "a",
    props: {
      "src": "https://badge.fury.io/js/%40zettel%2Fcore.svg",
      "alt": "@zettel/core"
    }
  })), /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://badge.fury.io/js/%40zettel%2Freact"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "img",
    components: components,
    parentName: "a",
    props: {
      "src": "https://badge.fury.io/js/%40zettel%2Freact.svg",
      "alt": "@zettel/react"
    }
  }))), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, "Getting started with @zettel/core and @zettel/react"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Right now we only have the packages ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "inlineCode",
    components: components,
    parentName: "p"
  }, "core"), " and ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "inlineCode",
    components: components,
    parentName: "p"
  }, "react"), ", you'll need those to get started."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "pre",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "code",
    components: components,
    parentName: "pre",
    props: {
      "metaString": null
    }
  }, "yarn add @zettel/core @zettel/react\n")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Now that you have them installed, here's a basic example of a plaintext editor:"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "pre",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "code",
    components: components,
    parentName: "pre",
    props: {
      "className": "language-jsx",
      "metaString": ""
    }
  }, "import * as React from 'react';\nimport { useState } from 'react'\nimport { EditorState } from '@zettel/core'\nimport Editor from '@zettel/react'\n\nconst text = `[One \uD83D\uDE05Line][And another line of text][And another line]`\n\nconst App = () => {\n  const [editorState, setEditorState] = useState(() => EditorState.fromJSON({\n    text,\n    ranges: [],\n    entityMap: {}\n  }))\n\n  return (\n    <Editor\n      htmlAttrs={{ spellCheck: false, autoFocus: true, className: 'editor'}}\n      onChange={setEditorState}\n      editorState={editorState}\n    />\n  );\n}\n\nexport default App;\n")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "For more examples ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://github.com/juliankrispel/zettel/tree/master/site/src/examples"
    }
  }, "have a look here")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, "Current Roadmap"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "This changes a lot. To focus as much as possible I'll keep this small."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "ul",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "Firefox, Safari, Chrome support"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "rendering text"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "render blocks"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "keeping selection in sync"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "All editing operations"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "render non-text media"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "react view layer"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "render text fragments"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "redo/undo"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "UTF-16 support for editing"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "IME Event handling"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", "Android support (via Input Events Level 2) ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "li",
    props: {
      "href": "https://github.com/basecamp/trix/blob/master/src/trix/controllers/level_2_input_controller.coffee"
    }
  }, "thanks Trix \u2764\uFE0F")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": true,
      "disabled": true
    }
  }), " ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "li",
    props: {
      "href": "https://developer.mozilla.org/en-US/docs/Mozilla/IME_handling_guide"
    }
  }, "IME support")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": false,
      "disabled": true
    }
  }), " ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "li",
    props: {
      "href": "https://github.com/juliankrispel/zettel/issues/8"
    }
  }, "rtl support")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": false,
      "disabled": true
    }
  }), " ", "Support for parser integration"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": false,
      "disabled": true
    }
  }), " ", "Prototype collaborative editing"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": false,
      "disabled": true
    }
  }), " ", "Start writing docs and publishing exampples on codesandbox"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul",
    props: {
      "className": "task-list-item"
    }
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "input",
    components: components,
    parentName: "li",
    props: {
      "type": "checkbox",
      "checked": false,
      "disabled": true
    }
  }), " ", "Alternative view layers (Vuejs/svelte/angular)")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, "Thanks"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "This project wouldn't have come this far without the influence of open source projects such as:"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "ul",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "li",
    props: {
      "href": "https://github.com/facebook/draft-js"
    }
  }, "draft-js")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "li",
    props: {
      "href": "https://github.com/ianstormtaylor/slate"
    }
  }, "slatejs")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "li",
    props: {
      "href": "https://github.com/ProseMirror/prosemirror"
    }
  }, "prosemirror")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "li",
    props: {
      "href": "https://github.com/Microsoft/vscode/issues"
    }
  }, "vscode")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "li",
    props: {
      "href": "https://github.com/basecamp/trix"
    }
  }, "trix"))));
});